<template>
  <div class="markers">
    <div v-show="loading" class="loading-indicator center-block"></div>
    <div v-if="sortedActiveMarkers.length" class="row marker-list">
      <div class="col-md-12">
        <h2>{{ $t("marker.active") }}</h2>
        <markers-table :markers="sortedActiveMarkers" @trash="deleteMarker"></markers-table>
      </div>
    </div>
    <div class="row" v-show="!loading">
      <div class="col-md-4 col-md-offset-4">
        <router-link
          class="btn btn-primary btn-full-width"
          tag="button"
          :to="{ path: '/marker/edit' }">
        {{ $t("marker.add") }}
        </router-link>
      </div>
    </div>
    <div v-if="sortedFutureMarkers.length" class="row marker-list">
      <div class="col-md-12">
        <h2>{{ $t("marker.future")}}</h2>
        <markers-table :markers="sortedFutureMarkers" @trash="deleteMarker"></markers-table>
      </div>
    </div>
    <div v-if="sortedPastMarkers.length" class="row marker-list">
      <div class="col-md-12">
        <h2>{{ $t('marker.past')}}</h2>
        <markers-table :markers="sortedPastMarkers" @trash="deleteMarker"></markers-table>
      </div>
    </div>
    <div v-show="!loading">
      <v-pagination
        v-model="page"
        @input="fetchMarkersData()"
        :length="amountPages"
        :total-visible="10"
      ></v-pagination>
    </div>
  </div>
</template>

<script>
// Render a list of markers

import MarkersTable from './markersList/MarkersTable.vue'
import MarkerRepository from '../repositories/MarkerRepository.js'
import {store, refreshGlobalState} from '../store'
import dates from '../services/dates'
import events from '../services/events'

export default {
  components: {
    MarkersTable
  },
  data () {
    return {
      markers: [],
      timer: '',
      loading: true,
      pageSize: 20,
      page: 1
    }
  },
  mounted () {
    // make sure we have initialized the global state
    // (i.e. retrieved the current team id from the backend)
    // before fetching the list of markers
    refreshGlobalState(store).then(() => {
      this.fetchMarkersData()
    })
  },
  methods: {
    fetchMarkersData () {
      MarkerRepository.fetchTeamMarkers(
        store.state.teamId, this.page, this.pageSize
      ).then(markers => {
        this.markers = markers
        this.loading = false
      })
      .catch(error => {
        this.loading = false
        events.emit('error', error)
      })
    },
    deleteMarker (marker) {
      MarkerRepository.delete(marker).then(() => {
        // give some time for backend cache invalidation
        setTimeout(() => { this.fetchMarkersData() }, 50)
      })
    }
  },
  computed: {
    // Generate sorted lists of markers based on their status (upcoming, active, etc.)
    sortedActiveMarkers () {
      return this.markers.slice().filter(function (m) {
        // FIXME: implement a smarter way of doing this
        // there are some issues when there is a discrepancy between
        // the backend time and browser time
        return m.is_active
      }).sort(sortMarkersStartAsc)
    },
    sortedFutureMarkers () {
      return this.markers.slice().filter(function (m) {
        return dates.parseDate(m.starts_at) > dates.now()
      }).sort(sortMarkersStartAsc)
    },
    sortedPastMarkers () {
      return this.markers.slice().filter(function (m) {
        return dates.parseDate(m.ends_at) < dates.now()
      }).sort(sortMarkersEndDesc)
    },
    amountPages () {
      return Math.ceil(this.markers.count / this.pageSize) || 1
    }
  }
}

function sortMarkersEndDesc (a, b) {
  return Date.parse(b.ends_at) - Date.parse(a.ends_at)
}
function sortMarkersStartAsc (a, b) {
  return Date.parse(a.starts_at) - Date.parse(b.starts_at)
}

</script>
